export default __webpack_public_path__ + "images/1f0161ddaf0cf59fa5145217f6a3d8b5.svg";